import type { WsInboundEnvelope } from "./wsInboundEnvelope";
import { optFiniteNumber } from "./wsPayloadCoercion";

export interface CallMissedWsPayload {
  type: "call_missed";
  missed_count?: number;
}

export function parseCallMissedPayload(
  envelope: WsInboundEnvelope,
): CallMissedWsPayload | null {
  if (envelope.type !== "call_missed") return null;
  return {
    type: "call_missed",
    missed_count: optFiniteNumber(envelope.missed_count),
  };
}
